module.exports = __webpack_public_path__ + "img/success-link.76f2fae6.png";